import { isLoading } from "../../../dataStore/actions/appUI";
import { useDispatch } from "ko-data-store";
import toastNotify from "geNotyf";
import manageReportsService, {
  IAgencyOption,
  IReportOption,
  ITierOption,
} from "./manageReportsService";

class TierAssignmentsViewModel {
  dispatch = useDispatch();
  tierOptions: ko.ObservableArray<ITierOption> = ko.observableArray([]);
  selectedOption: ko.Observable<ITierOption | null> = ko.observable(null);
  availableAgencies: ko.ObservableArray<IAgencyOption> = ko.observableArray([]);
  assignedAgencies: ko.ObservableArray<IAgencyOption> = ko.observableArray([]);

  availableReports: ko.ObservableArray<IReportOption> = ko.observableArray([]);
  assignedReports: ko.ObservableArray<IReportOption> = ko.observableArray([]);

  agencyAssignColumns = [
    { text: "id", datafield: "id", hidden: true, columnType: "number" },
    { text: "Name", datafield: "name", columnType: "textbox" },
  ];
  agencyAssignDataFields = [
    { name: "id", type: "string" },
    { name: "name", type: "string" },
  ];

  reportAssignColumns = [
    { text: "id", datafield: "id", hidden: true, columnType: "number" },
    { text: "Name", datafield: "name", columnType: "textbox" },
    { text: "Description", datafield: "description", columnType: "textbox" },
    {
      text: "URL",
      datafield: "url",
      columnType: "textbox",
      filterable: false,
    },
    { text: "Category", datafield: "category", columnType: "textbox" },
  ];

  reportAssignDataFields = [
    { name: "id", type: "string" },
    { name: "name", type: "string" },
    { name: "category", type: "string" },
    { name: "description", type: "string" },
    { name: "url", type: "string" },
  ];

  constructor() {
    this.loadTierOptions().then(() => {
      this.selectedOption.subscribe((val) => this.handleTierChange(val));
    });
  }

  handleTierChange = async (option: ITierOption | null) => {
    try {
      if (!option) {
        this.availableAgencies([]);
        this.availableReports([]);
        this.assignedAgencies([]);
        this.assignedReports([]);
        return;
      }

      this.dispatch(isLoading(true));
      const response = await manageReportsService.fetchAssignmentOptions(
        option.tierId
      );

      this.availableAgencies(response.availableAgencies ?? []);
      this.assignedAgencies(response.assignedAgencies ?? []);

      this.availableReports(response.availableReports ?? []);
      this.assignedReports(response.assignedReports ?? []);
    } catch (error) {
      console.error("Error handling tier change:", error);
    } finally {
      this.dispatch(isLoading(false));
    }
  };

  handleSaveTierAssignments = async () => {
    try {
      if (!this.selectedOption()) {
        console.warn("No tier selected for saving changes.");
        return;
      }

      const payload = {
        assignedAgencies: this.assignedAgencies().map((agency) => agency.id),
        assignedReports: this.assignedReports().map((report) => report.id),
      };

      this.dispatch(isLoading(true));
      await manageReportsService.updateAssignmentOptions(
        this.selectedOption().tierId,
        payload
      );
      toastNotify.success("Changes saved successfully!");
    } catch (error) {
      console.error("Error saving changes:", error);
    } finally {
      this.dispatch(isLoading(false));
    }
  };

  loadTierOptions = async () => {
    try {
      this.dispatch(isLoading(true));
      const response = await manageReportsService.fetchTierOptions();
      this.tierOptions(response);
    } catch (error) {
      console.error("Failed to fetch tier options:", error);
    } finally {
      this.dispatch(isLoading(false));
    }
  };
}

export default TierAssignmentsViewModel;
